function get_social_count_facebook(url, accessToken, target) {
	$.ajax({
    url: 'https://graph.facebook.com/v3.0/?fields=engagement',
    dataType:'jsonp',
    data: {
      id: url,
      access_token: accessToken
    },
	}).done(function(res) {
    if (res.engagement && res.engagement.share_count) {
      $(target).text(res.engagement.share_count);
    } else {
      $(target).text('0');
    }
  }).fail(function() {
    $(target).text('0');
  });
}

function get_social_count_hatena(url, target) {
  $.ajax({
    url:'https://b.hatena.ne.jp/entry.count?url=' + url,
    dataType: 'jsonp'
  }).done(function(data) {
    $(target).text(data);
  }).fail(function() {
    $(target).text('0');
  });
}

// hatena blog entry-count
$(function() {
	var url = location.href,
      target = '.js-count-hatena';
	get_social_count_hatena(url, target);
});